import { createSlice } from "@reduxjs/toolkit";

import {
  getNotificationThunk,
  markAllNotificationsAsReadThunk,
  markNotificationAsReadThunk,
} from "state/action/notifications";

// Initial state
const initialState = {
  // Get Notification inisial state
  getNotification: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Mark notification as read initial state
  markAsRead: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Mark all notifications as read initial state
  markAllAsRead: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },

  // Notification object value
  notification_object_value: "",
};

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setGetNotificationObjectValue: (state, action) => {
      return {
        ...state,
        Notification_object_value: action.payload,
      };
    },
    // note: clear state
    setClearGetNotificationObjectValue: (state, _) => {
      return {
        ...state,
        Notification_object_value: "",
      };
    },
    setClearCreateNotificationInputBody: (state, _) => {
      return {
        ...state,
        proposed_rental_fee: "",
        proposed_service_charge: "",
        proposed_duration: "",
        proposed_deposit: "",
        proposed_payment_method: "",
        Notification_notes: "",
        status: "",
        proposed_by: "",
      };
    },
    setCreateNotificationInputBody: (state, action) => {
      return {
        ...state,
        createNotificationInputBody: action.payload,
      };
    },
    setClearGetNotification: (state, _) => {
      return {
        ...state,
        getNotification: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearCreateNotification: (state, _) => {
      return {
        ...state,
        createNotification: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearUpdateNotification: (state, _) => {
      return {
        ...state,
        updateNotification: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearDeleteNotification: (state, _) => {
      return {
        ...state,
        deleteNotification: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearAllNotificationState: (state, _) => {
      return {
        ...state,
        // Get Notification inisial state
        getNotification: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },

        // Delete Notification inisial state
        deleteNotification: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Notification object value
        notification_object_value: "",
      };
    },
  },
  extraReducers(builder) {
    builder
      // Get Notification reducer
      .addCase(getNotificationThunk.pending, (state, _) => {
        return {
          ...state,
          getNotification: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getNotificationThunk.fulfilled, (state, action) => {
        return {
          ...state,
          getNotification: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getNotificationThunk.rejected, (state, action) => {
        return {
          ...state,
          getNotification: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      .addCase(markNotificationAsReadThunk.pending, (state) => {
        return {
          ...state,
          markAsRead: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      }) // Mark notification as read reducer
      .addCase(markNotificationAsReadThunk.fulfilled, (state, action) => {
        const updatedNotifications =
          state.getNotification.data?.data?.notifications.map(
            (notification) =>
              notification._id === action.payload.data._id
                ? { ...notification, read: true }
                : notification
          );
        return {
          ...state,
          markAsRead: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
          getNotification: {
            ...state.getNotification,
            data: {
              ...state.getNotification.data,
              data: { ...state.getNotification.data.data, notifications: updatedNotifications },
            },
          },
          unreadCount: state.unreadCount > 0 ? state.unreadCount - 1 : 0,
        };
      })
      .addCase(markNotificationAsReadThunk.rejected, (state, action) => {
        return {
          ...state,
          markAsRead: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // Mark all notifications as read reducer
      .addCase(markAllNotificationsAsReadThunk.pending, (state) => {
        return {
          ...state,
          markAllAsRead: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(markAllNotificationsAsReadThunk.fulfilled, (state, action) => {
        const updatedNotifications =
          state.getNotification.data?.data?.notifications.map(
            (notification) => ({
              ...notification,
              read: true,
            })
          );
        return {
          ...state,
          markAllAsRead: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
          getNotification: {
            ...state.getNotification,
            data: {
              ...state.getNotification.data,
              data: { ...state.getNotification.data.data, notifications: updatedNotifications },
            },
          },
          unreadCount: 0,
        };
      })
      .addCase(markAllNotificationsAsReadThunk.rejected, (state, action) => {
        return {
          ...state,
          markAllAsRead: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      });
  },
});

export const notificationAction = {
  ...notificationSlice.actions,
  getNotificationThunk,
  markAllNotificationsAsReadThunk,
  markNotificationAsReadThunk,
};

export function selectNotificationObjectValue(state) {
  return state?.notification?.notification_object_value;
}

export function selectNotification(state) {
  return state?.notification;
}

export default notificationSlice.reducer;
